import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import CareTypeModal from './CareTypeModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import logo from '../assets/aspen_logo.png';
import './Navbar.css';

const Navbar = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
  const [isContactOpen, setIsContactOpen] = useState(false);

  const handleGetStartedClick = (e) => {
    e.preventDefault();
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const scrollToFastCare = (e) => {
    e.preventDefault();
    const fastCareSection = document.querySelector('.fast-care');
    if (fastCareSection) {
      fastCareSection.scrollIntoView({ behavior: 'smooth' });
    }
    // Close mobile menu if open
    if (isMobile) {
      setIsMenuOpen(false);
      document.body.classList.remove('menu-open');
    }
  };
  // Toggle mobile menu
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    if (!isMenuOpen) {
      document.body.classList.add('menu-open');
    } else {
      document.body.classList.remove('menu-open');
    }
  };

  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 992;
      setIsMobile(mobile);
      if (!mobile) {
        setIsMenuOpen(false);
        document.body.classList.remove('menu-open');
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Close menu when clicking on a link
  const closeMenu = () => {
    if (isMobile) {
      setIsMenuOpen(false);
      document.body.classList.remove('menu-open');
    }
    setIsContactOpen(false);
  };

  return (
    <>
      <nav className="navbar">
        <div className="navbar-container">
          <div className="navbar-brand">
            <button 
              className="hamburger" 
              onClick={toggleMenu}
              aria-label="Toggle menu"
              aria-expanded={isMenuOpen}
            >
              <FontAwesomeIcon icon={isMenuOpen ? faTimes : faBars} />
            </button>
            <Link to="/" className="logo-container" onClick={closeMenu}>
              <img src={logo} alt="Aspen Quick Care Logo" className="nav-logo" />
              <h1>Aspen Quick Care</h1>
            </Link>
          </div>
          <div className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
            <ul>
              <li><Link to="/" onClick={closeMenu}>Home</Link></li>
              <li><Link to="/services" onClick={closeMenu}>Services</Link></li>
              <li><Link to="/providers" onClick={closeMenu}>Providers</Link></li>
              <li><Link to="/about" onClick={closeMenu}>About</Link></li>
              <li
                className={`contact-dropdown ${isContactOpen ? 'open' : ''}`}
                onMouseEnter={() => {
                  if (!isMobile) setIsContactOpen(true);
                }}
                onMouseLeave={() => {
                  if (!isMobile) setIsContactOpen(false);
                }}
              >
                <a
                  href="#contact"
                  onClick={(e) => {
                    e.preventDefault();
                    if (isMobile) {
                      setIsContactOpen(!isContactOpen);
                      return;
                    }
                    // Desktop uses hover to open; clicking scrolls to contact section
                    closeMenu();
                    scrollToFastCare(e);
                  }}
                >
                  Contact Us <span className="dropdown-arrow">▼</span>
                </a>
                <div className="contact-dropdown-menu">
                  <div className="contact-dropdown-list">
                    <div className="contact-dropdown-row">
                      <span className="contact-dropdown-location">Spring Creek</span>
                      <a
                        className="contact-dropdown-phone"
                        href="tel:7757383000"
                        onClick={closeMenu}
                      >
                        775-738-3000
                      </a>
                    </div>
                    <div className="contact-dropdown-row">
                      <span className="contact-dropdown-location">Elko</span>
                      <a
                        className="contact-dropdown-phone"
                        href="tel:7759932800"
                        onClick={closeMenu}
                      >
                        775-993-2800
                      </a>
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <a 
                  href="#get-started" 
                  className="appointment-btn" 
                  onClick={(e) => {
                    e.preventDefault();
                    closeMenu();
                    handleGetStartedClick(e);
                  }}
                >
                  Get Started
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <div className={`overlay ${isMenuOpen ? 'active' : ''}`} onClick={closeMenu}></div>
      <CareTypeModal isOpen={isModalOpen} onClose={handleCloseModal} />
    </>
  );
};

export default Navbar;
